import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d28d4e82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "WorkplaceItemsContainer" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center items-center text-center mt-3"
}
const _hoisted_3 = {
  key: 1,
  class: "WorkplaceItemsContainer__container"
}
const _hoisted_4 = { class: "relative flex items-center justify-end mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "WorkplaceItemsContainer__columns"
}
const _hoisted_6 = { class: "flex items-center justify-end mt-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/workplace/top.svg",
  alt: "top-img"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_workplace_filters = _resolveComponent("workplace-filters")!
  const _component_loader = _resolveComponent("loader")!
  const _component_refresh_icon = _resolveComponent("refresh-icon")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_columns_icon = _resolveComponent("columns-icon")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_workplace_items = _resolveComponent("workplace-items")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_workplace_filters, {
      loading: _ctx.state.is_loading,
      onSubmit: _ctx.onApplyFilters,
      onReset: _ctx.onResetFilters
    }, null, 8, ["loading", "onSubmit", "onReset"]),
    (_ctx.state.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary"
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_new_button, {
              class: "NewButton--outline NewButton--30 ml-3",
              onClick: _ctx.loadItems
            }, {
              default: _withCtx(() => [
                _createVNode(_component_refresh_icon, { class: "WorkplaceItemsContainer__icon" }),
                _createTextVNode(" Обновить ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_new_button, {
              class: "NewButton--outline NewButton--30 ml-3",
              onClick: _ctx.toggle
            }, {
              default: _withCtx(() => [
                _createVNode(_component_columns_icon, { class: "WorkplaceItemsContainer__icon" }),
                _createTextVNode(" Колонки ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.state.is_open)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.columns, (column, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `column-${idx}`,
                      class: "WorkplaceItemsContainer__columns-item"
                    }, [
                      _createVNode(_component_new_checkbox, {
                        class: "checkbox--blue checkbox--light",
                        value: _ctx.state.columns[idx].isChecked,
                        "onUpdate:value": ($event: any) => ((_ctx.state.columns[idx].isChecked) = $event),
                        label: _ctx.getColumnName(column.name)
                      }, null, 8, ["value", "onUpdate:value", "label"])
                    ]))
                  }), 128)),
                  _createVNode(_component_new_checkbox, {
                    class: "border-t mt-5 pt-3 checkbox--blue checkbox--light WorkplaceItemsContainer__columns-item",
                    value: _ctx.isAllColumnsChecked,
                    label: "Все колонки",
                    "onUpdate:value": _ctx.onAllColumnsSelect
                  }, null, 8, ["value", "onUpdate:value"]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_new_button, {
                      loading: _ctx.state.is_excel_loading,
                      disabled: _ctx.state.is_excel_loading,
                      class: "NewButton--medium NewButton--square",
                      hint: "Скачать Excel",
                      onClick: _ctx.onSetColumns
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Подтвердить ")
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled", "onClick"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_workplace_items, {
            loading: _ctx.state.is_loading,
            failed: _ctx.state.is_failed,
            "items-ltl": _ctx.state.items_ltl,
            "items-ftl": _ctx.state.items_ftl,
            "first-column": _ctx.state.first_column,
            columns: _ctx.filteredColumns,
            type: _ctx.filters.type,
            onRefresh: _ctx.loadItems,
            onScroll: _ctx.onScroll
          }, null, 8, ["loading", "failed", "items-ltl", "items-ftl", "first-column", "columns", "type", "onRefresh", "onScroll"]),
          _withDirectives(_createVNode(_component_new_button, {
            class: "NewButton--medium NewButton--square TopBtn",
            onClick: _ctx.scrollToTop
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.state.is_top_btn]
          ])
        ]))
  ]))
}